export const PRIVACY_POLICY_LINK = 'https://docs.panels.ai/privacy-policy/';
export const TERMS_OF_SERVICE_LINK = 'https://docs.panels.ai/terms-of-use/';
